import React from 'react'
import { GET_RCS_INVENTORY } from './queries'
import Grid from '@material-ui/core/Grid'
import FormControl from '@material-ui/core/FormControl'
import FormGroup from '@material-ui/core/FormGroup'
import TextField from '@material-ui/core/TextField'
import FormHelperText from '@material-ui/core/FormHelperText'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Switch from '@material-ui/core/Switch'
import Checkbox from '@material-ui/core/Checkbox'
import Select from 'react-select'
import { CircularProgress } from '@material-ui/core'
import { DatePicker } from 'material-ui-pickers'
import InstallationImagesSection from './InstallationImagesSection'
const SelectReact = Select

const SolutionTypeOption = props => {
    const { onSelect, onFocus, isSelected, option, children, className } = props
    const handleMouseDown = event => {
        event.preventDefault()
        event.stopPropagation()
        onSelect(option, event)
    }
    const handleMouseEnter = event => {
        onFocus(option, event)
    }

    return (
        <div
            className={className}
            onMouseDown={handleMouseDown}
            onMouseEnter={handleMouseEnter}
            onMouseMove={handleMouseEnter}
            title={option.title}
            style={{ display: 'flex', alignItems: 'center' }}
        >
            <Checkbox checked={!!isSelected} color="primary" />
            <span>{children}</span>
        </div>
    )
}


const VehicleInfoStep = (props) => {
    const {
        state,
        classes,
        client,
        handleInputChange,
        checkVlpnValidity,
        handleChangeSpeedSensor,
        checkSpeedSensorValidity,
        checkSpeedLimitValidity,
        handleDateChange,
        handleChangeIdlingSpeed,
        handleChangeInputParameter,
        handleChangeMultiplicationFactor,
        handleChangeDevice,
        handleChangePhoneNumber,
        handleChangeAccessories,
        handleTechnicianCategoryChange,
        handleTaabiSelectChange,
        handleFreelancerSelectChange,
        handleChangeSubscription,
        checkItemValidity,
        handleChangeMake,
        handleChangeModelNew,
        checkDualEngineVoltageValidity,
        checkAdblueCapacityValidity,
        checkBaselineDataForFEValidity,
        checkBaselineDistanceValidity,
        checkBaselineHoursValidity,
        handleVideoTelematicsMenuChange,
        handleVtidChange,
        handleVideoTelematicsIdChange,
        documentUploadNewData,
        timezoneOptions,
        handleChangeTimezone,
        // Add any other handlers if needed
    } = props

    const [showAllManual, setShowAllManual] = React.useState(false)

    let allSpeedSensor = []
    allSpeedSensor[0] = {
        value: 'GPS SPEED SENSOR',
        label: 'Gps speed sensor'
    }
    allSpeedSensor[1] = {
        value: 'DELTA_DISTANCE_CALCULATION',
        label: 'Delta Distance'
    }
    allSpeedSensor[2] = {
        value: 'ODOMETRIC',
        label: 'Odometric'
    }

    let allIdlingSpeed = [
        { value: 0, label: 0 },
        { value: 1, label: 1 },
        { value: 2, label: 2 },
        { value: 3, label: 3 }
    ]

    return (
        <Grid
            container
            fullwidth
            style={{
                marginTop: '20px'
            }}
        >
            {/* Column Titles */}
            <Grid container spacing={3}>
                <Grid item xs={6}>
                    <h3>
                        {state.vehicleSegment == 'DG Set'
                            ? 'Vehicle/DG Info'
                            : 'Vehicle Info'}
                    </h3>
                </Grid>
                <Grid item xs={6}>
                    <h3>Device and SIM Info</h3>
                </Grid>
            </Grid>

            {/* Column 1: Vehicle Info */}
            <Grid item xs={6} sm={6}>
                {state.vehicleSegment === 'DG Set' && (
                    <FormControl className="selectbox">
                        <FormGroup className="form-input">
                            <TextField
                                id="vlpn"
                                name="vlpn"
                                className="textfield"
                                margin="dense"
                                label={
                                    state.vehicleSegment == 'DG Set'
                                        ? 'Vehicle/Asset Number'
                                        : 'Vehicle Number'
                                }
                                value={state.vlpn}
                                required
                                onChange={handleInputChange('vlpn')}
                                error={!state.isVlpnValid}
                                onBlur={checkVlpnValidity(client)}
                            />

                            <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                            >
                                {!state.isVlpnValid
                                    ? state.vlpnres
                                    : ''}
                            </FormHelperText>
                        </FormGroup>
                    </FormControl>
                )}

                <Grid container spacing={1}>
                    {state.vehicleSegment != 'DG Set' && (
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        value={state.isDualEngine}
                                        checked={state.isDualEngine}
                                        onChange={handleInputChange('isDualEngine')}
                                        name="dualEngineToggle"
                                        color="primary"
                                    />
                                }
                                label="Dual Engine"
                            />
                            {state.deviceType && state.deviceType != 'obd' && (
                                <FormControlLabel
                                    control={
                                        <Switch
                                            value={state.duplicateVehicle}
                                            checked={state.duplicateVehicle}
                                            onChange={handleInputChange('duplicateVehicle')}
                                            name="duplicateVehicleToggle"
                                            color="primary"
                                        />
                                    }
                                    label="Duplicate Vehicle"
                                />
                            )}
                        </Grid>
                    )}

                    {state.vehicleSegment != 'DG Set' && (
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        value={state.hasArm}
                                        checked={state.hasArm}
                                        onChange={handleInputChange('hasArm')}
                                        name="armToggle"
                                        color="primary"
                                    />
                                }
                                label="Arm Included?"
                            />
                        </Grid>
                    )}

                    <Grid item xs={12}>
                        <FormControlLabel
                            control={
                                <Switch
                                    value={state.isRotationSensor}
                                    checked={state.isRotationSensor}
                                    onChange={e => {
                                        props.setState({
                                            isRotationSensor: !state.isRotationSensor
                                        })
                                    }}
                                    name="isRotationSensor"
                                    color="primary"
                                />
                            }
                            label="Rotation Sensor Available"
                        />
                    </Grid>

                    {state.vehicleSegment != 'DG Set' && (
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        value={state.isIndividualViewOrCombinedView}
                                        checked={state.isIndividualViewOrCombinedView}
                                        onChange={handleInputChange('isIndividualViewOrCombinedView')}
                                        name="isIndividualViewOrCombinedView"
                                        color="primary"
                                    />
                                }
                                label={
                                    state.isIndividualViewOrCombinedView
                                        ? 'Dual Tank Combined View'
                                        : 'Dual Tank Individual View'
                                }
                            />
                        </Grid>
                    )}

                    <Grid item xs={12}>
                        <FormControlLabel
                            control={
                                <Switch
                                    value={state.isElockConnection}
                                    checked={state.isElockConnection}
                                    onChange={handleInputChange('isElockConnection')}
                                    name="isElockConnectionToggle"
                                    color="primary"
                                />
                            }
                            label="E-LOCK Connection?"
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <FormControlLabel
                            control={
                                <Switch
                                    value={state.istachoenabled}
                                    checked={state.istachoenabled}
                                    onChange={handleInputChange('istachoenabled')}
                                    name="istachoenabledToggle"
                                    color="primary"
                                />
                            }
                            label="Is Tachometer Enabled?"
                        />
                    </Grid>

                    {state.istachoenabled && (
                        <Grid container spacing={2} style={{ paddingLeft: '15px', paddingRight: '15px' }}>
                            <Grid item xs={6}>
                                <TextField
                                    label="Idle RPM *"
                                    value={state.tachoidlerpm}
                                    onChange={handleInputChange('tachoidlerpm')}
                                    type="number"
                                    fullWidth
                                    margin="dense"
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    label="Shift Hours *"
                                    value={state.tachoshifthours}
                                    onChange={handleInputChange('tachoshifthours')}
                                    type="number"
                                    fullWidth
                                    margin="dense"
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    label="Engine On Voltage (min)"
                                    value={state.tachoengineonmin}
                                    onChange={handleInputChange('tachoengineonmin')}
                                    type="number"
                                    fullWidth
                                    margin="dense"
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    label="Engine On Voltage (max)"
                                    value={state.tachoengineonmax}
                                    onChange={handleInputChange('tachoengineonmax')}
                                    type="number"
                                    fullWidth
                                    margin="dense"
                                />
                            </Grid>
                        </Grid>
                    )}
                </Grid>

                {/* Video Telematics Section */}
                <Grid item xs={12} style={{ marginTop: '20px' }}>
                    <label style={{ marginRight: '10px' }}>
                        Video Telematics
                    </label>
                    <FormControl style={{ minWidth: '60%' }}>
                        <FormGroup className="form-input">
                            <Select
                                options={state.videoTelematicsType}
                                value={state.selectedVTM}
                                onChange={handleVideoTelematicsMenuChange}
                                placeholder="Select Video Telematics"
                            />
                        </FormGroup>
                    </FormControl>
                </Grid>

                {state.selectedVTM && state.selectedVTM.value && (
                    <Grid item xs={12} style={{ marginTop: '10px' }}>
                        {state.selectedVTM.value === 'mettax' ? (
                            <div style={{ width: '100%' }}>
                                {state.dashcamRegistrationsLoading ? (
                                    <CircularProgress size={30} />
                                ) : (
                                    <React.Fragment>
                                        <label style={{ marginRight: '10px' }}>Mettax VT ID *</label>
                                        <FormControl className="selectbox" style={{ minWidth: '60%' }}>
                                            <Select
                                                options={state.vtidOptions}
                                                value={state.selectedVtid}
                                                onChange={handleVtidChange}
                                                placeholder="Select ID"
                                            />
                                        </FormControl>
                                        {state.selectedVtid && (
                                            <Grid container spacing={2} style={{ marginTop: '10px' }}>
                                                <Grid item xs={6}>
                                                    <TextField label="SIM ID" disabled value={state.selectedSimId} fullWidth />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <TextField label="Memory Card" disabled value={state.selectedMemoryCardId} fullWidth />
                                                </Grid>
                                            </Grid>
                                        )}
                                    </React.Fragment>
                                )}
                            </div>
                        ) : (
                            <FormControl className="selectbox" style={{ minWidth: '60%' }}>
                                <TextField
                                    label={`Video Telematics Id${state.selectedVTM ? '*' : ''}`}
                                    value={state.videoTelematicsId}
                                    onChange={handleVideoTelematicsIdChange}
                                    fullWidth
                                />
                            </FormControl>
                        )}
                    </Grid>
                )}

                {/* Manual Entry Section */}
                <div
                    style={{
                        padding: '10px',
                        borderRadius: '5px',
                        border: '2px solid #f2f2f2',
                        marginTop: '20px'
                    }}
                >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                        <h4 style={{ margin: 0 }}>Manual Entry Section</h4>
                        <button
                            type="button"
                            onClick={() => setShowAllManual(!showAllManual)}
                            style={{
                                background: 'transparent',
                                border: '1px solid #ccc',
                                borderRadius: '4px',
                                padding: '4px 12px',
                                cursor: 'pointer',
                                fontSize: '12px'
                            }}
                        >
                            {showAllManual ? 'Show Less' : 'Show All Fields'}
                        </button>
                    </div>

                    {/* Mandatory Fields */}

                    {state.vehicleSegment != 'DG Set' && (
                        <React.Fragment>
                            <FormControl className="selectbox" fullWidth style={{ marginTop: '10px' }}>
                                <label>Ported Vehicle *</label>
                                <Select
                                    options={[{ value: 'Yes', label: 'Yes' }, { value: 'No', label: 'No' }]}
                                    value={state.portedVehicle}
                                    onChange={handleInputChange('portedVehicle')}
                                    placeholder="Ported Vehicle *"
                                />
                            </FormControl>

                            <FormControl className="selectbox" fullWidth style={{ marginTop: '10px' }}>
                                <label>isTesting Vehicle *</label>
                                <Select
                                    options={[{ value: 'Testing', label: 'Testing' }, { value: 'Active', label: 'Active' }]}
                                    value={state.isTestingVehicle}
                                    onChange={handleInputChange('isTestingVehicle')}
                                    placeholder="isTesting Vehicle *"
                                />
                            </FormControl>

                            <FormControl className="selectbox" fullWidth style={{ marginTop: '10px' }}>
                                <label>Speed Sensor *</label>
                                <Select
                                    options={allSpeedSensor}
                                    value={state.speedSensor}
                                    onChange={handleChangeSpeedSensor}
                                    placeholder="Select Speed Sensor *"
                                />
                            </FormControl>

                            <TextField
                                label="Maximum Speed Limit *"
                                value={state.speedLimit}
                                onChange={handleInputChange('speedLimit')}
                                error={!state.isSpeedLimitValid}
                                helperText={!state.isSpeedLimitValid ? 'Maximum speed limit 10-160' : ''}
                                onBlur={checkSpeedLimitValidity}
                                type="number"
                                fullWidth
                                margin="normal"
                            />

                            <FormControl className="selectbox" fullWidth style={{ marginTop: '10px' }}>
                                <label>Timezone (Optional)</label>
                                <Select
                                    options={timezoneOptions}
                                    value={state.selectedTimezone}
                                    onChange={handleChangeTimezone}
                                    placeholder="Select Timezone (Default: Client Timezone)"
                                    isClearable={true}
                                />
                            </FormControl>

                            <FormControl className="selectbox" fullWidth style={{ marginTop: '10px' }}>
                                <label>Owner Type</label>
                                <Select
                                    options={[
                                        { value: 'Self', label: 'Self' },
                                        { value: 'Hired', label: 'Hired' }
                                    ]}
                                    value={state.owner_type || 'Self'}
                                    onChange={handleInputChange('owner_type')}
                                    placeholder="Owner Type"
                                    clearable={false}
                                />
                            </FormControl>
                        </React.Fragment>
                    )}

                    <InstallationImagesSection
                        client={client}
                        fileNames={state.fileNames}
                        documentUploadNewData={documentUploadNewData}
                        vehicleSolutionType={state.solutionType}
                        mode="add"
                        required
                        onChange={imageState => props.setState(imageState)}
                        errorMessage={state.errorMessage}
                    />

                    {/* Non-Mandatory Fields (Hidden by default) */}
                    {showAllManual && (
                        <React.Fragment>
                            {state.vehicleSegment != 'DG Set' && (
                                <FormControl className="selectbox" fullWidth style={{ marginTop: '10px' }}>
                                    <label>Vehicle Customized Body Type</label>
                                    <Select
                                        options={state.vehiclecustomizedbodytype && state.vehiclecustomizedbodytype.map(o => ({ label: o, value: o }))}
                                        value={state.vehicleCustomizedBodyType ? { label: state.vehicleCustomizedBodyType, value: state.vehicleCustomizedBodyType } : null}
                                        onChange={o => props.setState({ vehicleCustomizedBodyType: o ? o.value : '' })}
                                        placeholder="Customize Body Type"
                                    />
                                </FormControl>
                            )}
                            <TextField label="Equipment Serial Number" value={state.equipmentSerialNumber} onChange={handleInputChange('equipmentSerialNumber')} fullWidth margin="normal" />
                            <TextField label="Equipment Name" value={state.equipmentName} onChange={handleInputChange('equipmentName')} fullWidth margin="normal" />
                            <DatePicker label="Commissioning Date" format="DD/MM/YYYY" value={state.commissioningDate.date} onChange={handleDateChange('commissioningDate')} fullWidth />
                            <TextField label="Department" value={state.department} onChange={handleInputChange('department')} fullWidth margin="normal" />
                            <TextField label="Contractor Name" value={state.contractorName} onChange={handleInputChange('contractorName')} fullWidth margin="normal" />
                            <TextField label="Plant Code" value={state.plant_code} onChange={handleInputChange('plant_code')} fullWidth margin="normal" />
                            <TextField label="Equipment Type" value={state.equipment_type} onChange={handleInputChange('equipment_type')} fullWidth margin="normal" />
                            <TextField label="Equipment Number" value={state.equipment_no} onChange={handleInputChange('equipment_no')} fullWidth margin="normal" />
                        </React.Fragment>
                    )}

                    {/* Conditionally Mandatory fields */}
                    {(showAllManual || state.isDualEngine) && (
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <TextField label="Engine on Voltage" value={state.eon_voltage} onChange={handleInputChange('eon_voltage')} required={state.isDualEngine} fullWidth margin="normal" />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField label="Engine off Voltage" value={state.eoff_voltage} onChange={handleInputChange('eoff_voltage')} required={state.isDualEngine} fullWidth margin="normal" />
                            </Grid>
                        </Grid>
                    )}

                    {(showAllManual) && (
                        <TextField label="Fuel Tank Capacity" value={state.fuelTankCapacity} onChange={handleInputChange('fuelTankCapacity')} required={state.vehicleSegment == 'DG Set'} type="number" fullWidth margin="normal" />
                    )}

                    {(showAllManual || (state.deviceType && state.deviceType.toLowerCase() === 'obd')) && (
                        <TextField
                            label={state.deviceType && state.deviceType.toLowerCase() === 'obd' ? "Adblue Capacity *" : "Adblue Capacity"}
                            value={state.adblueCapacity}
                            onChange={handleInputChange('adblueCapacity')}
                            required={state.deviceType && state.deviceType.toLowerCase() === 'obd'}
                            error={state.isAdblueCapacityValid === false}
                            onBlur={checkAdblueCapacityValidity}
                            fullWidth
                            margin="normal"
                        />
                    )}

                    {showAllManual && (
                        <React.Fragment>
                            {state.vehicleSegment != 'DG Set' && (
                                <React.Fragment>
                                    <FormControl className="selectbox" fullWidth style={{ marginTop: '10px' }}>
                                        <label>No. Of Gears</label>
                                        <Select
                                            options={state.noofgears && state.noofgears.map(o => ({ label: o, value: o }))}
                                            value={state.noOfGears ? { label: state.noOfGears, value: state.noOfGears } : null}
                                            onChange={o => props.setState({ noOfGears: o ? o.value : null })}
                                        />
                                    </FormControl>
                                    <TextField label="Gear Ratio" value={state.gearRatio} onChange={handleInputChange('gearRatio')} fullWidth margin="normal" />
                                </React.Fragment>
                            )}
                            {state.vehicleSegment == 'DG Set' && (
                                <React.Fragment>
                                    <TextField label="BHP" value={state.bhp} onChange={handleInputChange('bhp')} fullWidth margin="normal" />
                                    <FormControl fullWidth style={{ marginTop: '10px' }}>
                                        <label>Phase</label>
                                        <Select options={state.phaseOptions} value={state.phase} onChange={handleInputChange('phase')} />
                                    </FormControl>
                                    <TextField label="Engine Model" value={state.engineModel} onChange={handleInputChange('engineModel')} fullWidth margin="normal" />
                                    <TextField label="Genset Controller" value={state.gensetController} onChange={handleInputChange('gensetController')} fullWidth margin="normal" />
                                </React.Fragment>
                            )}
                            {state.vehicleSegment != 'DG Set' && (
                                <React.Fragment>
                                    <FormControl fullWidth style={{ marginTop: '10px' }}>
                                        <label>Idling Speed</label>
                                        <Select options={allIdlingSpeed} value={state.idlingSpeed} onChange={handleChangeIdlingSpeed} />
                                    </FormControl>
                                    <TextField label="Asset Working Hours" type="number" value={state.inputParameter} onChange={handleChangeInputParameter} fullWidth margin="normal" />
                                    <TextField label="Asset Multiplication Factor" type="number" value={state.multiplicationFactor} onChange={handleChangeMultiplicationFactor} fullWidth margin="normal" />
                                </React.Fragment>
                            )}
                        </React.Fragment>
                    )}

                    {/* Invoice Info (Conditionally Mandatory) */}
                    {(showAllManual || state.customerType == 'Paid' || state.vehicleSegment == 'DG Set') && (
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <TextField label="Invoice Number" value={state.invoiceNumber} onChange={handleInputChange('invoiceNumber')} required={state.customerType == 'Paid' || state.vehicleSegment == 'DG Set'} fullWidth margin="normal" />
                            </Grid>
                            <Grid item xs={6}>
                                <DatePicker label="Invoice Date" value={state.invoiceDate.date} onChange={handleDateChange('invoiceDate')} required={state.customerType == 'Paid' || state.vehicleSegment == 'DG Set'} fullWidth />
                            </Grid>
                        </Grid>
                    )}

                    {/* Baseline FE (Non-Mandatory) */}
                    {showAllManual && state.vehicleSegment != 'DG Set' && (
                        <React.Fragment>
                            <FormControl fullWidth style={{ marginTop: '10px' }}>
                                <label>Baseline Data Type FE</label>
                                <Select
                                    options={state.baselinedatatypefe && state.baselinedatatypefe.map(o => ({ label: o, value: o.toLowerCase() }))}
                                    value={state.baselineDataType}
                                    onChange={o => props.setState({ baselineDataType: o ? o.value : '', baselineDataForFE: null })}
                                />
                            </FormControl>
                            {state.baselineDataType && (
                                <TextField
                                    label={state.baselineDataType === 'kmpl' ? 'Baseline FE (KMPL)' : 'Baseline FE (LPH)'}
                                    value={state.baselineDataForFE}
                                    onChange={handleInputChange('baselineDataForFE')}
                                    fullWidth
                                    margin="normal"
                                />
                            )}
                        </React.Fragment>
                    )}
                </div>
            </Grid>

            {/* Column 2: Device and SIM Info */}
            <Grid item xs={6} sm={6} style={{ paddingLeft: '20px' }}>
                <FormControl className="selectbox" fullWidth>
                    <label>Device *</label>
                    <Select
                        options={state.deviceDetails}
                        value={state.serialNumber}
                        onChange={handleChangeDevice(client)}
                        placeholder="Select Device *"
                    />
                </FormControl>

                <TextField label="Model Name" value={state.modelName} disabled fullWidth margin="normal" />
                <TextField label="Device Type" value={state.deviceType} disabled fullWidth margin="normal" />

                <FormControl className="selectbox" fullWidth style={{ marginTop: '10px' }}>
                    <label>Phone No *</label>
                    <Select
                        options={state.simDetails}
                        value={state.phoneNumber}
                        onChange={handleChangePhoneNumber(client)}
                        placeholder="Select Phone No *"
                    />
                </FormControl>

                <TextField label="Service Provider" value={state.simProvider} disabled fullWidth margin="normal" />
                <TextField label="SIM Number" value={state.simNumber} disabled fullWidth margin="normal" />

                <FormControl className="selectbox" fullWidth style={{ marginTop: '10px' }}>
                    <label>Accessories</label>
                    <Select options={state.accessoryDetails} value={state.accessories} onChange={handleChangeAccessories} />
                </FormControl>

                <FormControl className="selectbox" fullWidth style={{ marginTop: '10px' }}>
                    <label>Technician Category</label>
                    <Select
                        options={[{ label: 'Taabi Personal', value: 'Technician - Taabi Personal' }, { label: 'Freelancer', value: 'Technician - Freelancer' }]}
                        value={state.technicianCategory ? { label: state.technicianCategory, value: state.technicianCategory } : null}
                        onChange={handleTechnicianCategoryChange}
                    />
                </FormControl>

                {state.technicianCategory === 'Technician - Taabi Personal' && (
                    <FormControl fullWidth style={{ marginTop: '10px' }}>
                        <Select options={state.assignedTechniciansTaabi} value={state.selectedTaabiTechnician} onChange={handleTaabiSelectChange} placeholder="Select Taabi Technician" />
                    </FormControl>
                )}
                {state.technicianCategory === 'Technician - Freelancer' && (
                    <FormControl fullWidth style={{ marginTop: '10px' }}>
                        <Select options={state.assignedTechniciansFreelancer} value={state.selectedFreelancerTechnician} onChange={handleFreelancerSelectChange} placeholder="Select Freelancer Technician" />
                    </FormControl>
                )}

                <FormControl fullWidth style={{ marginTop: '10px' }}>
                    <label>Subscription</label>
                    <Select options={state.subscriptionDetails} value={state.subscriptionId} onChange={handleChangeSubscription} placeholder="Select Subscription" />
                </FormControl>

                <TextField label="Engine On Hours" value={state.engineOnHours} onChange={handleInputChange('engineOnHours')} fullWidth margin="normal" />
                <TextField label="Odometric Distance" value={state.odometerDistance} onChange={handleInputChange('odometerDistance')} fullWidth margin="normal" />

                {(state.deviceType === 'obd' || state.deviceType === 'OBD') && state.vehicleSegment !== 'DG Set' && (
                    <div style={{ marginTop: '20px', padding: '10px', backgroundColor: '#f9f9f9' }}>
                        <h4>Gear Related Info</h4>
                        <label>Select Make *</label>
                        <SelectReact
                            options={state.makesList.map(item => ({ value: item.id, label: item.make }))}
                            value={state.vehicleMakeId ? { value: state.vehicleMakeId, label: state.vehicleMake } : null}
                            onChange={handleChangeMake}
                        />
                        <label style={{ marginTop: '10px', display: 'block' }}>Select Model *</label>
                        <SelectReact
                            options={state.modelsList.map(item => ({ value: item.id, label: item.model }))}
                            value={state.vehicleModel ? { value: state.vehicleModelId, label: state.vehicleModel } : null}
                            onChange={handleChangeModelNew}
                        />
                    </div>
                )}
            </Grid>
        </Grid>
    )
}

export default VehicleInfoStep



// WEBPACK FOOTER //
// ./src/components/Modules/VehicleRegistartion/VehicleInfoStep.jsx